import { Button } from '@/components/ui/button'
import { useOnboarding } from './useOnboarding'

export function OnboardingNav() {
  const { state, goToStep, forwardAction } = useOnboarding()
  const showBack = state.currentStep > 0

  return (
    <div className="mt-6 flex items-center justify-between border-t pt-6">
      {showBack ? (
        <Button type="button" variant="ghost" onClick={() => goToStep(state.currentStep - 1)}>
          Back
        </Button>
      ) : (
        <span />
      )}
      {forwardAction ? (
        <Button
          type="button"
          onClick={() => {
            void forwardAction.onClick()
          }}
          disabled={forwardAction.disabled}
        >
          {forwardAction.label}
        </Button>
      ) : (
        <span />
      )}
    </div>
  )
}
